import Vue from "vue";
import Vuex from "vuex";
import * as consts from "./const";
import * as Api from "@/common/report.api";
import axios from './http'
import { Message } from 'element-ui'
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    parentId:null,
    continer_left: "181px",
    asidelist: [],
    isCollapse: false,
    tabIndex: "1",
    homeTop: 0, // 有无滚动页面
    pieIndex: "",
    setIndexName: "",
    topSlide: true,
    dialog: false, // 理疗师弹窗
    perQuery: {
      perName: "",
      perContrastName: ""
    },
    query_data: {},
    query_table: {},
    query_common: {
      startTime: '',
      endTime: ''
    },
    colors: [
      "#A39FFE",
      "#FF79C4",
      "#4ED9FF",
      "#FFDB7D",
      "#FF826F",
      "#58E49F",
      "#FFBD71",
      "#C5E778",
      "#7DC6FD",
      "#F1D69A",
      "#FCB9D8",
      "#E4DAA4",
      "#FF826F",
      "#58E49F",
      "#FFBD71",
      "#C5E778",
      "#7DC6FD",
      "#F1D69A",
      "#FCB9D8",
      "#E4DAA4",
      "#FFBD71",
      "#C5E778",
      "#7DC6FD",
      "#F1D69A",
      "#FCB9D8",
      "#E4DAA4",
      "#F1D69A",
      "#FCB9D8",
      "#E4DAA4",
      "#FF826F",
      "#58E49F",
      "#FFBD71",
      "#FCB9D8",
      "#E4DAA4",
    ],
    colorObj: {},
    eachColor: [],
    disabled: [false, false],
    uploadTable: [],
    indexList: [],
    choosedCoupons: {},
    choosedActivity: {},
    noData: false,
    tableType: '',
    areaList: [], // 区域
    companyList: [], // 公司
    groupList: [], //集团
  },
  mutations: {
    changeNoData(state) {
      state.noData = true;
    },
    initNoData(state) {
      state.noData = false;
    },
    clearColor(state) {
      state.colorObj = {};
    },
    addIndex(state, res) {
      state.indexList.push(res);
    },
    clearIndex(state) {
      state.indexList = [];
    },
    countWidth(state) {
      state.continer_left = state.continer_left === "181px" ? "59px" : "181px";
    },
    collapse(state, val) {
      state.isCollapse = val;
    },
     getAsideId(state, val) {
      state.parentId = val;
    },
    getAsideInfo(state, nav) {
        state.asidelist = nav;
    },
    getScroll(state, val) {
      state.homeTop = parseInt(val.h) === 0 ? 0 : 1;
    },
    setIndexName(state, res) {
      if (res.data) {
        state.setIndexName = res.data.indexName;
      } else {
        state.setIndexName = "";
      }
    },
    // 高级筛选
    setTopSlide(state, res) {
      state.topSlide = res.data;
    },
    // 头部筛选条件
    setQueryCommon(state, res) {
      if (Object.keys(res.data).length) {
        state.query_common = Object.assign({}, state.query_common, res.data);
      } else {
        state.query_common = {};
      }
    },
    // 筛选条件
    setQueryData(state, res) {
        const log = console.log.bind(console)
    //   log('set query data----------------store', res)
      if (Object.keys(res.data).length) {
        state.query_data = Object.assign({}, state.query_data, res.data);
      } else {
        state.query_data = {};
      }
    },
    // 筛选表格数据
    setQueryTable(state, res) {
      if (Object.keys(res.data).length) {
        state.query_table = Object.assign({}, state.query_table, res.data);
      } else {
        state.query_table = {};
      }
    },
    getPieIndex(state, index) {
      state.pieIndex = index;
    },
    setDialog(state, res) {
      if (res.data) {
        state.dialog = res.data;
      } else {
        state.dialog = false;
      }
    },
    // 对比时，将多选指标变一个
    setIndicator(state) {
      // console.log(state.query_data)
      if (Object.keys(state.query_data).length) {
        state.query_data.indicatorIDs.splice(1, 1);
      }
    },
    // 上传表格
    sendTable(state, res) {
      state.uploadTable = res.data;
      // console.log(state.uploadTable)
    },
    // 优惠券分析和活动分析，当某一个雄安模块选择某一项，则跳转默认选择
    chooseCoupons(state, data) {
      state.choosedCoupons = data;
    },
    chooseActivity(state, data) {
      state.choosedActivity = data;
    },
    setTableType(state, type) {
        state.tableType = type
    },
    setGroup(state, data){
        state.groupList = data.map(v => {
          v.constKey = Number(v.constKey)
          return v
        })
    },
    setCompany(state, data) {
        state.companyList = data.map(v => {
          v.constKey = Number(v.constKey)
          return v
        })
    },
    setArea(state, data) {
        state.areaList = data.map(v => {
          v.constKey = Number(v.constKey)
          return v
        })
    },
  },

  getters: {
    getGroup(state) {
      return state.groupList
    },
    getCompany(state) {
      return state.companyList;
    },
    getArea(state) {
      return state.areaList;
    },
  },
  actions:{
    async getGroup({commit}, data){
      const res = await Api.getGroupList(data)
      if(!res.data || res.data.errorCode !== 0){
        return res.data && Message.error(res.data.errorMsg)
      }
      commit('setGroup',res.data.data)
    },
    async getCompanyList({commit}, data){
      const res = await Api.getCompanyList(data)
      if(!res.data || res.data.errorCode !== 0){
        return res.data && Message.error(res.data.errorMsg)
      }
      commit('setCompany',res.data.data)
    },
    async getAreaList({commit}, data){
      const res = await Api.getAreaList(data)
      if(!res.data || res.data.errorCode !== 0){
        return res.data && Message.error(res.data.errorMsg)
      }
      commit('setArea',res.data.data)
    },
    getRight ({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("getAsideId",data);
      });
    },
  }
});
export default store;
